import { createAction, props } from '@ngrx/store';
import { MenuItem } from 'primeng/api';

/**
 * @ deprecated não esta mais sendo usado breadcrumb no state global
 */
// export const updateBreadcrumb = createAction('[Layout] Update breadcrumb', props<{ items: MenuItem[] }>());

export const changePageTitle = createAction('[Layout] Change page title', props<{ title: string }>());

export const toggleFullscreen = createAction('[Layout] Toggle fullscreen', props<{ toggle?: boolean }>());
